export const getSystem = state => state.getIn(['system']).toJS();
export const getI18n = state => getSystem(state).i18n;
export const getQuotations = state => state.quotations;

export const getQuotationsStore = state => state.getIn(['quotations']);
export const getQuotation = (state, id) =>
  getQuotationsStore(state)
    .getIn(['quotations', id])
    .toJS();
export const getQuotationOfferV2 = (state, id) => state.getIn(['quotations', 'offerV2', id]).toJS();
export const getQuotationsStrings = state => getQuotationsStore(state).getIn(['strings']);

export const getPrefUserInfo = state => state.getIn(['auth', 'userInfo', 'pref']).toJS();
